import { createQueryKeys } from '@/libs/react-query/queryKeysFactory';
import type { QueryParams } from '@/types/common/api.type';

export const customerReviewKey = createQueryKeys<QueryParams>('CustomerReview');
